import request from '@/services/interceptor.js'

export const get_macroAree = () => {
    return request({
        url: '/macroarea',
        method: 'get',
        loadingBar: true
    })
}

export const get_macroArea = (id) => {
    return request({
        url: `/macroarea/${id}`,
        method: 'get',
        loadingBar: true
    })
}

export const create_macroArea = (par) => {
    return request({
        url: '/macroarea',
        method: 'post',
        data: par,
        loadingBar: true
    })
}

export const update_macroArea = (id, par) => {
    return request({
        url: `/macroarea/${id}`,
        method: 'put',
        data: par,
        loadingBar: true
    })
}

export const delete_macroArea = (id) => {
    return request({
        url: `/macroarea/${id}`,
        method: 'delete',
        loadingBar: true
    })
}